/** @jsxImportSource @emotion/react */
import React from "react";
import { jsx, css } from "@emotion/react";
import { useEffect, useState, forwardRef } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import Swal from "sweetalert2";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Loading from "./Loading";
import Layout from "./Layout";
import { DataGrid, selectedIdsLookupSelector } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import { loginState, configState } from "../lib/State";
import log from "../lib/log";
import pr from "../lib/pr";
import CenterSelect from "./CenterSelect";
import MemberSearch from "./MemberSearch";
import { Select, MenuItem, AppBar, Toolbar, Typography, RadioGroup, Radio, FormControlLabel,
FormLabel
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import MobileDatePicker from "@mui/lab/MobileDatePicker";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { ko } from "date-fns/locale";
import moment from "moment";
import ProductSearch from "./ProductSearch";
import { lightGreen } from "@mui/material/colors";
import get_token from '../lib/get_token';

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

// 등록하기 팝업
function MemberAdd(props) {
  const { login, onClosePop,seq } = props;
  const token = get_token();

  const [sdate, setSdate] = useState(null);
  const [edate, setEdate] = useState(null);
  const [cname, setCname] = useState('');
  const [mname, setMname] = useState('');
  const [couponName, setCouponName] = useState('');
  const [useAmountf, setUseAmountf] = useState(0);
  const [gubun, setGubun] = useState('');
  const [rate, setRate] = useState(0);
  const [amountf, setAmountf] = useState(0);
  const [useDate, setUseDate] = useState(null);
  const [canUse, setCanUse] = useState('');

  const onSubmit = async () => {    
    
    const postData = {
      token:token,
      cid:login.cid,
      level:login.level,
      mcd:login.mcd,
      seq:seq,
      sdate: sdate,
      edate: edate,
      can_use:canUse,
    }       
    let result = await axios.post(configState.api + "/gympass_admin/dcoupon_issue_edit", postData );
    if (result.data.success !== 1) {
      Swal.fire(result.data.msg);
      return;
    } else {
      Swal.fire({ title: "수정되었습니다.", showCloseButton: true }).then(
        (result) => {
          onClosePop();          
        }
      );
    }
  }

  const load_data = async () => {
    let result = await axios.post(
      configState.api + "/gympass_admin/dcoupon_issue_one",
      {
        token: token,
        cid: login.cid,
        level: login.level,
        mcd: login.mcd,
        seq: seq,
      }
    );

    if (result.data.success === 1) {
      setCname(result.data.row.cname);
      setMname(result.data.row.mname);
      setCouponName(result.data.row.name);
      setUseAmountf(result.data.row.use_amountf);      
      setGubun(result.data.row.gubun);      
      setUseDate(result.data.row.use_date);   
      setRate(result.data.row.rate);      
      setAmountf(result.data.row.amountf);    
      setCanUse(result.data.row.can_use);      
      setSdate(result.data.row.sdate);      
      setEdate(result.data.row.edate);      
    } else {
      Swal.fire(result.data.msg);
      return;
    }
  };
  useEffect(() => {
    load_data();
  }, []);

  const onDeleteClick = () => {
    Swal.fire({
      title: "삭제하시겠습니까?",
      showConfirmButton: true,
      showCancelButton: true,
    })
      .then(async (result) => {
        if (result.isConfirmed) {
          let result = await axios.post(
            configState.api + "/gympass_admin/dcoupon_issue_del",
            {
              token: token,
              cid: login.cid,
              level: login.level,
              mcd: login.mcd,
              seq: seq,
            }
          );
          if (result.data.success === 1) {
            onClosePop();
          } else {
            Swal.fire(result.data.msg);
          }
        }
      })
      .catch((e) => alert(e));
  };

  return (
    <Box>       

      <Box
        css={css`
          padding: 20px 60px;
        `}
      >                          

         <Box>센터명 : {cname} </Box>
         <Box>고객명 : {mname} </Box>
         <Box>쿠폰명 : {couponName}</Box>         
         <Box>쿠폰구분 : {gubun}</Box>
         <Box>할인율 : {rate}%</Box>
         <Box>할인금액 : {amountf}원</Box>
         <Box>사용금액 : {useAmountf}원</Box>
         <Box>사용일 : {useDate}</Box>

       {/* 사용가능 */}
       <FormControl
          fullWidth
          css={css`
            margin-top: 10px;
          `}
        >
          <FormLabel>사용가능</FormLabel>
          <RadioGroup
            row
            aria-labelledby="demo-radio-buttons-group-label"
            name="canUse"
            onChange={(e)=>setCanUse(e.target.value)}
            value={canUse}
          >
            <FormControlLabel value="Y" control={<Radio />} label="Y" />
            <FormControlLabel value="N" control={<Radio />} label="N" />
          </RadioGroup>
        </FormControl>

        {/* 시작일 */}
        <Box sx={{ display: "flex", mt: 1 }}>
          <Box>
            <LocalizationProvider dateAdapter={AdapterDateFns} locale={ko}>
              <MobileDatePicker
                allowSameDateSelection={true}
                value={sdate}
                label="시작일"
                renderInput={(params) => <TextField {...params} />}
                onChange={(newDate)=>setSdate(moment(newDate).format("YYYY-MM-DD"))}
                inputFormat={"yyyy.MM.dd"}
                autoComplete="off"
              />
            </LocalizationProvider>
          </Box>
          <Box sx={{ ml: 1 }}>
            <LocalizationProvider dateAdapter={AdapterDateFns} locale={ko}>
              <MobileDatePicker
                name="edate"
                allowSameDateSelection={true}
                value={edate}
                label="종료일"
                renderInput={(params) => <TextField {...params} />}
                onChange={(newDate)=>setEdate(moment(newDate).format("YYYY-MM-DD"))}
                inputFormat={"yyyy.MM.dd"}
                autoComplete="off"
              />
            </LocalizationProvider>
          </Box>
        </Box>  

        <Box
          css={css`
            text-align: center;
            margin-top: 30px;
          `}
        >
          <Button variant="contained" onClick={onSubmit}>
            수정완료
          </Button>
          <Button variant="contained" onClick={onDeleteClick}  color="warning" sx={{ml:1}}>
            삭제
          </Button>          
          <Button
            variant="contained"
            color="warning"
            css={css`
              margin-left: 10px;
            `}
            onClick={onClosePop}
          >
            취소
          </Button>
        </Box>
      </Box>
    </Box>
  );
}

export default MemberAdd;
